module.exports = __webpack_public_path__ + "assets/priceoff3.jpg?30cdaabcc5029000f702c16518767b87";